const React = require("react");

function BookmarkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z"
  }));
}

module.exports = BookmarkIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/BookmarkIcon.js
 ** module id = 456
 ** module chunks = 0
 **/